import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { Loading } from '../components/SurfingLoading';
import { getErrorMessage } from '../helpers/errorMessages';
import { usePaymentLink } from '../hooks/usePaymentLink';
import {
    CartServiceType,
    useShoppingCartStore,
} from '../store/shoppingCart/shoppingCartStore';
import { Checkout } from './Checkout';

const PageContainer = styled.div`
    body #root header {
        display: none;
    }
    height: 100%;

    > div {
        height: 100%;
        justify-content: center;
    }
`;

const Pay = () => {
    const { setCartValues, cartValues, setIsPaymentLinkCart } = useShoppingCartStore();
    const { paymentLinkId } = useParams();
    const paymentLink = usePaymentLink(paymentLinkId);
    const navigateTo = useNavigate();

    const handleNotFound = () => {
        toast.error('Link de pagamento não encontrado', { autoClose: false });
        navigateTo('/');
    };

    const handleError = (error: Error) => {
        toast.error(getErrorMessage(error.message), { autoClose: false });
        navigateTo('/');
    };

    useEffect(() => {
        if (cartValues && cartValues?.length > 0) return;
        if (paymentLink.isLoading) return;
        if (paymentLink.error) return handleError(paymentLink.error);
        if (!paymentLink.data) return handleNotFound();

        setIsPaymentLinkCart(true);

        paymentLink.data!.products.forEach(checkoutItem => {
            setCartValues(
                {
                    id: checkoutItem.product.id.toString(),
                    date: new Date(checkoutItem.date),
                    title: checkoutItem.product.exhibitionName,
                    type: CartServiceType.Waves,
                    value: checkoutItem.value,
                    client: {
                        ...checkoutItem.client,
                        foreigner: paymentLink.data.person.foreigner || false,
                    },
                },
                false
            );
        });
    }, [cartValues, paymentLink]);

    if (
        !cartValues ||
        cartValues?.length === 0 ||
        paymentLink.isLoading ||
        !paymentLink.data
    )
        return <Loading />;

    return (
        <PageContainer>
            <Checkout
                shouldHideRecommendations={true}
                shouldBlockEditing={true}
                isPaymentLink={true}
                forcedCheckoutId={paymentLink.data.id}
            />
        </PageContainer>
    );
};

export default Pay;
